import { NgModule } from '@angular/core';
import '@angular/localize/init';
import { SnackBarModule } from '@epicuro-next/ataraxia/snack-bar';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { DataListsModule } from '@epicuro-next/data/lists';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { AccountsStateModule } from '@epicuro-next/state/accounts-state';
import { EventTrackerStateModule } from '@epicuro-next/state/event-tracker';
import { ListEntitiesModule } from '@epicuro-next/state/list-entities';
import { ListProductReferenceEntitiesModule } from '@epicuro-next/state/list-product-reference-entities';
import { PBasketStateModule } from '@epicuro-next/state/p-basket-state';
import { SessionStateModule } from '@epicuro-next/state/session-state';
import { ShopTheLookStateModule } from '@epicuro-next/state/shop-the-look-state';
import { StateSitesStateModule } from '@epicuro-next/state/site-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BulkAddEffects } from './state/effects/bulk-add/bulk-add.effects';
import { EpicShowEffects } from './state/effects/epic-show/epic-show.effects';
import { EpicShowProductsEffects } from './state/effects/epic-show/products.effects';
import { ActiveListEffects } from './state/effects/list/active-list.effects';
import { BulkDeleteEffects } from './state/effects/list/bulk-delete.effects';
import { CloneEffects } from './state/effects/list/clone.effects';
import { CreateEffects } from './state/effects/list/create.effects';
import { DeleteEffects } from './state/effects/list/delete.effects';
import { ExportEffects } from './state/effects/list/export.effects';
import { FeedEffects } from './state/effects/list/feed.effects';
import { InitEffects } from './state/effects/list/init.effects';
import { LoadEffects } from './state/effects/list/load.effects';
import { ModifyItemsEffects } from './state/effects/list/modify-items.effects';
import { OpenedListEffects } from './state/effects/list/opened-list.effects';
import { ProductsEffects } from './state/effects/list/products.effects';
import { ResetEffects } from './state/effects/list/reset.effects';
import { RouteTrackingEffects } from './state/effects/list/route-tracking.effects';
import { SaveAllItemsEffects } from './state/effects/list/save-all-items.effects';
import { TrackListEffects } from './state/effects/list/track-list.effects';
import { UpdateEffects } from './state/effects/list/update.effects';
import { RouteEffects } from './state/effects/route.effects';
import { UserUiEffects } from './state/effects/user-ui.effects';
import { initialState, productListFeatureKey, reducers } from './state/store';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(productListFeatureKey, reducers, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
    EffectsModule.forFeature([
      LoadEffects,
      SaveAllItemsEffects,
      ModifyItemsEffects,
      CreateEffects,
      ActiveListEffects,
      CloneEffects,
      DeleteEffects,
      UpdateEffects,
      LoadEffects,
      InitEffects,
      OpenedListEffects,
      FeedEffects,
      ExportEffects,
      RouteEffects,
      BulkAddEffects,
      UserUiEffects,
      EpicShowEffects,
      EpicShowProductsEffects,
      BulkDeleteEffects,
      ResetEffects,
      TrackListEffects,
      RouteTrackingEffects,
      ProductsEffects,
    ]),
    SnackBarModule,
    PBasketStateModule,
    DataEngagementApiModule,
    ShopTheLookStateModule,
    ListEntitiesModule,
    ListProductReferenceEntitiesModule,
    ConfigurationModule,
    SessionStateModule,
    StateSitesStateModule,
    AccountsStateModule,
    EventTrackerStateModule,
    DataListsModule,
  ],
})
export class ProductListStoreModule {}
